/**
 * 全局配置文件
 */
export default {
  title: "惠民殡服-事件空间",
  logo: "W",
  key: 'wf',//配置主键,目前用于存储
  indexTitle: '惠民殡服-事件空间',
}
